import React, { Component } from 'react'
import $ from 'jquery';
import { EmbeddedFacebook } from './embeddeFacebook';
import { EmbeddedTwitter } from './embeddedTwitter';

import './socialBlock.css';

export default class SocialBlock extends Component {

    componentDidMount() {
        $.getScript('https://cdn.flipboard.com/web/buttons/js/flbuttons.min.js');
    }

    render() {
        return (
            <section id="social-block">
                <div className="container">
                    <div className="row">

                        <div className="col-xs-12 col-sm-4">
                            <div className="well">

                                <h4 className="text-uppercase">
                                    <img src="./img/flipboard.png" alt="" />
                                    flipboard
                                </h4>


                                <a data-flip-widget="mag"
                                    href="https://flipboard.com/@hrrp/nepal-housing-recovery-and-reconstruction-media-digest-50ltfqmmy">
                                    View my Flipboard Magazine.
                                    </a>

                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-4">
                            <div className="well">

                                <h4 className="text-uppercase">
                                    <img src="./img/facebook.png" alt="" />
                                    facebook
                                </h4>


                                <EmbeddedFacebook id="embeddedFacebook" />

                            </div>
                        </div>

                        <div className="col-xs-12 col-sm-4">
                            <div className="well">

                                <h4 className="text-uppercase">
                                    <img src="./img/twitter.png" alt="" />
                                    twitter
                                </h4>


                                <EmbeddedTwitter />

                            </div>
                        </div>

                    </div>
                </div>
            </section>
        )
    }
}
